import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { GlobalSettings } from '../shared/domain/configuration.model';
import {
  GET_GLOBAL_SETTINGS,
  GetGlobalSettingsFailureAction,
  GetGlobalSettingsSuccessAction,
  GlobalSettingsAction,
  UPDATE_GLOBAL_SETTINGS,
  UpdateGlobalSettingsAction,
  UpdateGlobalSettingsFailureAction,
  UpdateGlobalSettingsSuccessAction
} from './global-settings.actions';
import { GlobalSettingsService } from './global-settings.service';

@Injectable()
export class GlobalSettingsEffects {
  constructor(private actions$: Actions, private globalSettingsService: GlobalSettingsService) {}

  @Effect()
  getGlobalSettings$: Observable<GlobalSettingsAction> = this.actions$.pipe(
    ofType(GET_GLOBAL_SETTINGS),
    switchMap(() =>
      this.globalSettingsService
        .getGlobalSettings()
        .pipe(
          map((response: GlobalSettings) => new GetGlobalSettingsSuccessAction(response)),
          catchError(error => of(new GetGlobalSettingsFailureAction(error)))
        )
    )
  );

  @Effect()
  updateGlobalSettings$: Observable<GlobalSettingsAction> = this.actions$.pipe(
    ofType(UPDATE_GLOBAL_SETTINGS),
    map((action: UpdateGlobalSettingsAction) => action.payload),
    switchMap((payload: GlobalSettings) =>
      this.globalSettingsService
        .updateGlobalSettings(payload)
        .pipe(
          map(() => new UpdateGlobalSettingsSuccessAction(payload)),
          catchError(error => of(new UpdateGlobalSettingsFailureAction(error)))
        )
    )
  );
}
